// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Dimmer = ({ fill, svgComponents: { Circle, G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Circle cx="32" cy="30.32" r="2.58" />
            <Circle cx="33.94" cy="23.1" r="2.06" />
            <Circle cx="32" cy="15.87" r="1.81" />
            <Circle cx="26.71" cy="10.58" r="1.81" />
            <Circle cx="19.48" cy="8.65" r="1.55" />
            <Circle cx="12.26" cy="10.58" r="1.29" />
            <Circle cx="6.97" cy="15.87" r="1.03" />
            <Circle cx="5.03" cy="23.1" r="1.03" />
            <Circle cx="6.97" cy="30.32" r="1.03" />
            <Path d="M20,32.63a9.53,9.53,0,1,1,9.53-9.53A9.54,9.54,0,0,1,20,32.63Zm0-18.06a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,20,14.56Z" />
        </G>
    );
};

export default Dimmer;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/dimmer/index.js